import { render, staticRenderFns } from "./PendingUploads.vue?vue&type=template&id=5bb9299f&scoped=true"
import script from "./PendingUploads.vue?vue&type=script&lang=ts"
export * from "./PendingUploads.vue?vue&type=script&lang=ts"
import style0 from "./PendingUploads.vue?vue&type=style&index=0&id=5bb9299f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb9299f",
  null
  
)

export default component.exports